import moment from 'moment';
import { useMemo } from 'react';
import { SUBSCRIPTION_TYPE, Subscription } from 'types/IEquipmentEntry';
import { formatDate } from 'utils/date';

export interface SubscriptionInfo {
  hasPremium: boolean;
  isInitial: boolean;
  endsWithinDays: boolean;
  endsOn?: string;
  rawEndsOn?: string;
  nextPaymentDate?: string;
  rawNextPaymentDate?: string;
}

export default function useSubscriptionInfo(
  subscriptions: Subscription[] = [],
) {
  const subscriptionInfo = useMemo<SubscriptionInfo>(() => {
    const subscription =
      subscriptions.find(
        sub => sub.type === SUBSCRIPTION_TYPE.PREMIUM_TELEMATICS,
      ) ||
      subscriptions.find(
        sub => sub.type === SUBSCRIPTION_TYPE.INITIAL_TELEMATICS,
      );

    const endsOn = subscription?.endDate
      ? moment(subscription.endDate)
      : undefined;

    return {
      hasPremium: !!subscription,
      isInitial: subscription?.type === SUBSCRIPTION_TYPE.INITIAL_TELEMATICS,
      endsWithinDays: endsOn
        ? endsOn.isSameOrAfter(moment()) &&
          endsOn.isSameOrBefore(moment().add(90, 'days'))
        : false,
      endsOn: subscription?.endDate
        ? formatDate(subscription.endDate, 'DATE_FORMAT_READABLE')
        : undefined,
      rawEndsOn: subscription?.endDate,
      nextPaymentDate: subscription?.nextPaymentDate
        ? formatDate(subscription.nextPaymentDate, 'DATE_FORMAT_READABLE')
        : undefined,
      rawNextPaymentDate: subscription?.nextPaymentDate,
    };
  }, [subscriptions]);

  return subscriptionInfo;
}
